<template>
  <div>
    <!-- Componente ANR -->
    <ANRReportTable
      v-if="esOperacion === 'ANR'"
      :resultados="resultados"
      :total-items="totalItems"
      :items-por-pagina="itemsPorPagina"
      :pagina-actual="paginaActual"
      :loading="loading"
      :headers="headers"
      :es-operacion="esOperacion"
      @cambiar-pagina="$emit('cambiar-pagina', $event)"
      @cambiar-items-por-pagina="$emit('cambiar-items-por-pagina', $event)"
    />

    <!-- Componente Info Mora Financiamiento -->
    <InfoMoraReportTable
      v-else-if="esOperacion === 'Info Mora (Financiamiento)'"
      :resultados="resultados"
      :total-items="totalItems"
      :items-por-pagina="itemsPorPagina"
      :pagina-actual="paginaActual"
      :loading="loading"
      :headers="headers"
      :es-operacion="esOperacion"
      :totales="totales"
      @cambiar-pagina="$emit('cambiar-pagina', $event)"
      @cambiar-items-por-pagina="$emit('cambiar-items-por-pagina', $event)"
    />

    <!-- Componente Info Cobranzas Proyectadas -->
    <InfoCobranzasProyectadasReportTable
      v-else-if="esOperacion === 'Info Cobranzas Proyectadas'"
      :resultados="resultados"
      :total-items="totalItems"
      :items-por-pagina="itemsPorPagina"
      :pagina-actual="paginaActual"
      :loading="loading"
      :headers="headers"
      :es-operacion="esOperacion"
      :totales="totales"
      @cambiar-pagina="$emit('cambiar-pagina', $event)"
      @cambiar-items-por-pagina="$emit('cambiar-items-por-pagina', $event)"
    />

    <!-- Componente Info Cobranzas -->
    <InfoCobranzasReportTable
      v-else-if="esOperacion === 'Info Cobranzas'"
      :resultados="resultados"
      :total-items="totalItems"
      :items-por-pagina="itemsPorPagina"
      :pagina-actual="paginaActual"
      :loading="loading"
      :headers="headers"
      :es-operacion="esOperacion"
      :totales="totales"
      @cambiar-pagina="$emit('cambiar-pagina', $event)"
      @cambiar-items-por-pagina="$emit('cambiar-items-por-pagina', $event)"
    />

    <!-- Componente Financiamiento -->
    <FinanciamientoReportTable
      v-else-if="esOperacion === 'Financiamiento'"
      :resultados="resultados"
      :total-items="totalItems"
      :items-por-pagina="itemsPorPagina"
      :pagina-actual="paginaActual"
      :loading="loading"
      :headers="headers"
      :es-operacion="esOperacion"
      @cambiar-pagina="$emit('cambiar-pagina', $event)"
      @cambiar-items-por-pagina="$emit('cambiar-items-por-pagina', $event)"
    />

    <!-- Componente Info Cte y No Cte -->
    <InfoCteYNoCteReportTable
      v-else-if="esOperacion === 'Info Cte y No Cte'"
      :resultados="resultados"
      :total-items="totalItems"
      :items-por-pagina="itemsPorPagina"
      :pagina-actual="paginaActual"
      :loading="loading"
      :headers="headers"
      :es-operacion="esOperacion"
      @cambiar-pagina="$emit('cambiar-pagina', $event)"
      @cambiar-items-por-pagina="$emit('cambiar-items-por-pagina', $event)"
    />

    <!-- Componente Saldos HTC -->
    <SaldosHTCReportTable
      v-else-if="esOperacion === 'Reporte de Saldos - HTC'"
      :resultados="resultados"
      :total-items="totalItems"
      :items-por-pagina="itemsPorPagina"
      :pagina-actual="paginaActual"
      :loading="loading"
      :headers="headers"
      :es-operacion="esOperacion"
      :totales="totales"
      @cambiar-pagina="$emit('cambiar-pagina', $event)"
      @cambiar-items-por-pagina="$emit('cambiar-items-por-pagina', $event)"
    />

    <!-- Tabla base para otros tipos de operación -->
    <BaseReportTable
      v-else
      :resultados="resultados"
      :total-items="totalItems"
      :items-por-pagina="itemsPorPagina"
      :pagina-actual="paginaActual"
      :loading="loading"
      :headers="headers"
      :es-operacion="esOperacion"
      @cambiar-pagina="$emit('cambiar-pagina', $event)"
      @cambiar-items-por-pagina="$emit('cambiar-items-por-pagina', $event)"
    />
  </div>
</template>

<script>
import ANRReportTable from './ReportTables/ANRReportTable.vue';
import FinanciamientoReportTable from './ReportTables/FinanciamientoReportTable.vue';
import InfoMoraReportTable from './ReportTables/InfoMoraReportTable.vue';
import InfoCobranzasProyectadasReportTable from './ReportTables/InfoCobranzasProyectadasReportTable.vue';
import InfoCobranzasReportTable from './ReportTables/InfoCobranzasReportTable.vue';
import InfoCteYNoCteReportTable from './ReportTables/InfoCteYNoCteReportTable.vue';
import SaldosHTCReportTable from './ReportTables/SaldosHTCReportTable.vue';
import BaseReportTable from './ReportTables/BaseReportTable.vue';

export default {
  name: 'ReportTable',
  components: {
    ANRReportTable,
    FinanciamientoReportTable,
    InfoMoraReportTable,
    InfoCobranzasProyectadasReportTable,
    InfoCobranzasReportTable,
    InfoCteYNoCteReportTable,
    SaldosHTCReportTable,
    BaseReportTable,
  },
  mounted() {
    console.log('🏗️ ReportTable montado - esOperacion:', this.esOperacion);
    console.log('🏗️ Condición Financiamiento:', this.esOperacion === 'Financiamiento');
    console.log('🏗️ Condición ANR:', this.esOperacion === 'ANR');
    console.log('🏗️ Condición Info Mora:', this.esOperacion === 'Info Mora (Financiamiento)');
    console.log('🏗️ Condición Info Cobranzas Proyectadas:', this.esOperacion === 'Info Cobranzas Proyectadas');
    console.log('🏗️ Condición Info Cobranzas:', this.esOperacion === 'Info Cobranzas');
    console.log('🏗️ Condición Info Cte y No Cte:', this.esOperacion === 'Info Cte y No Cte');
    console.log('🏗️ Condición Saldos HTC:', this.esOperacion === 'Reporte de Saldos - HTC');
  },
  props: {
    resultados: {
      type: Array,
      default: () => [],
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    itemsPorPagina: {
      type: Number,
      default: 10,
    },
    paginaActual: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    esOperacion: {
      type: String,
    },
    totales: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['cambiar-pagina', 'cambiar-items-por-pagina'],
};
</script>

<style scoped>
/* El estilo ahora se maneja en los componentes individuales */
</style>
